import { Box, Grid, Skeleton } from "@mui/material";

export const JudgePageSkeleton = () => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            position: "relative",
            p: 1.5,
            justifyContent: "center"
        }}
    >
        <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid size={4} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton
                    variant="text"
                    sx={{ fontSize: 16,width: 80 }} />
            </Grid>
            <Grid size={4} sx={{ display: "flex", alignItems: "center" }}>
                <Skeleton
                    variant="text"
                    sx={{
                        fontSize: 16,
                        width: 80
                    }} />
            </Grid>
            <Grid size={4} sx={{ display: "flex", alignItems: "center" }}>
                <Skeleton variant="circular" width={40} height={40} />
            </Grid>
        </Grid>
        <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid size={4} sx={{ display: "flex", justifyContent: "center", width: 128 }} />
            <Grid size={4} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                {[1, 2, 3].map(() => (<Skeleton variant="rounded" width={40} height={40} />))}

            </Grid>
            <Grid size={4} sx={{ display: "flex", gap: 1, justifyContent: "center", width: 40 }} />
        </Grid>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            {[1, 2].map((_, i) => (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Skeleton
                        variant="text"
                        sx={{ width: i === 0 ? 150 : 100 }} />
                    {[1, 2, 3, 4].map(() => (
                        <Skeleton variant="rectangular" width={i === 0 ? 150 : 100} height={150} />
                    ))}
                </Box>
            ))}

            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton variant="text" sx={{ width: "100%" }} />
                <Skeleton variant="rectangular" width="100%" height={624} />
            </Box>
        </Box>

    </Box>
);
